module.exports = __webpack_public_path__ + "img/results_on.389038d9.svg";